import { render } from "./previewImageModal.vue?vue&type=template&id=68436e52&scoped=true"
import script from "./previewImageModal.vue?vue&type=script&lang=js"
export * from "./previewImageModal.vue?vue&type=script&lang=js"

import "./previewImageModal.vue?vue&type=style&index=0&id=68436e52&scoped=true&lang=css"

import exportComponent from "/var/www/html/conference/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68436e52"]])

export default __exports__